import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StaffNavbar from '../components/StaffNavbar';
import apiService from '../services/api';
import '../styles/StaffPages.css';

const StaffDashboard = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const currentUser = await apiService.fetchCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error('Failed to fetch dashboard data:', error);
        navigate('/login/');
      }
    };

    fetchDashboardData();
  }, [navigate]);

  return (
    <div className="admin-dashboard">
      <StaffNavbar activeSection="dashboard" />
      <div className="admin-main">
        <div className="admin-content">
          <h1 className="staff-page-header">Dashboard</h1>

          <p className="staff-page-content">
            Welcome to the admin dashboard{user ? `, ${user.first_name}` : ''}.
          </p>

          <p className="staff-page-content" style={{marginTop: '48px'}}>
            Manage rewards and gain insights about fans
          </p>

          <div className="dashboard-actions">
            <button
              className="dashboard-button"
              onClick={() => navigate('/staff/fans/')}
            >
              View Fans
            </button>
            <button
              className="dashboard-button"
              onClick={() => navigate('/staff/transactions/')}
            >
              View Transactions
            </button>
            <button
              className="dashboard-button"
              onClick={() => navigate('/staff/rewards/')}
            >
              Manage Rewards
            </button>
            <button
              className="dashboard-button"
              onClick={() => navigate('/staff/fulfillment/')}
            >
              Reward Delivery
            </button>
            <button
              className="dashboard-button"
              onClick={() => navigate('/staff/analytics/')}
            >
              View Analytics
            </button>
            {/* Content section hidden — see StaffNavbar's commented-out nav entry.
            <button
              className="dashboard-button"
              onClick={() => navigate('/staff/content/')}
            >
              Manage Content
            </button>
            */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffDashboard;